// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","ceros-container":"ceros-module__ceros-container___28v3o","cerosContainer":"ceros-module__ceros-container___28v3o"};